function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 369,
  cy: 370,
  rx: 369,
  ry: 370,
  fill: "#DBE6F8",
  fillOpacity: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 369,
  cy: 370.5,
  rx: 299,
  ry: 298.5,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 369,
  cy: 370.5,
  rx: 299,
  ry: 298.5,
  fill: "#A5C8FB",
  fillOpacity: 0.19
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 369,
  cy: 370.5,
  rx: 299,
  ry: 298.5,
  fill: "#8295B5",
  fillOpacity: 0.23
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 230.5,
  ry: 230,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 230.5,
  ry: 230,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 230.5,
  ry: 230,
  fill: "#396FBE",
  fillOpacity: 0.41
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_620_59454)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 369.5,
  cy: 370,
  rx: 158.5,
  ry: 159,
  fill: "#C4DBFF",
  fillOpacity: 0.38
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 369.5,
  cy: 370,
  rx: 158.5,
  ry: 159,
  fill: "#C4DBFF",
  fillOpacity: 0.38
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 369.5,
  cy: 370,
  rx: 158.5,
  ry: 159,
  fill: "#B5D1F8"
}));

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 141.5,
  ry: 142,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 141.5,
  ry: 142,
  fill: "#C4DBFF",
  fillOpacity: 0.38
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 368.5,
  cy: 370,
  rx: 141.5,
  ry: 142,
  fill: "#0D4EAC"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_620_59454)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M450 370C450 414.183 413.959 450 369.5 450C325.041 450 289 414.183 289 370C289 325.817 325.041 290 369.5 290C413.959 290 450 325.817 450 370ZM301.3 370C301.3 407.432 331.834 437.776 369.5 437.776C407.166 437.776 437.7 407.432 437.7 370C437.7 332.568 407.166 302.224 369.5 302.224C331.834 302.224 301.3 332.568 301.3 370Z",
  fill: "white"
}));

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 369.5,
  cy: 370,
  rx: 74.5,
  ry: 74,
  stroke: "#082F67",
  strokeWidth: 13,
  strokeDasharray: 466,
  strokeDashoffset: 466,
  fill: "transparent",
  fillOpacity: 1,
  id: "analyze-progress-ellipse",
  className: ""
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_620_59454",
  x: 181,
  y: 181,
  width: 377,
  height: 378,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  result: "effect1_foregroundBlur_620_59454"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_620_59454",
  x: 289,
  y: 290,
  width: 161,
  height: 164,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_620_59454"
})));

function SvgProgressNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 738,
    height: 740,
    viewBox: "0 0 738 740",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressNew);
export default __webpack_public_path__ + "static/media/progress-new.8fcf2630.svg";
export { ForwardRef as ReactComponent };